import { mensagemPadrao } from 'src/dados-estaticos'
import * as Yup from 'yup'

/**
 * Valida só os campos do formulário. As opções de pagamento vivem em
 * `useState` (fora do Unform) e são validadas no `adicionarOpcao` e no submit,
 * espelhando as invariantes de PlanoPagamentoNegociado.ValidarComposicao.
 */
export const schema = Yup.object().shape({
  // A obrigatoriedade da turma é checada no submit, não aqui: na edição o
  // campo é só leitura e nem chega ao formulário, o que faria um `required`
  // barrar o salvamento indevidamente.
  turmaId: Yup.string().notRequired(),
  validadeAte: Yup.string().required(mensagemPadrao),
  nomeContato: Yup.string().notRequired().max(200),
  emailConvite: Yup.string().email('Informe um e-mail válido.').notRequired(),
  cpfAluno: Yup.string().notRequired()
})
